const JOURNEY_KEY = 'fairday_analytics_journey_v1';
const ALIAS_KEY = 'fairday_analytics_alias_v1';

function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `journey_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export const createAnalyticsEventId = randomId;

export function getOrCreateJourneyId(storage: Pick<Storage, 'getItem' | 'setItem'> = window.localStorage): string {
  try {
    const existing = storage.getItem(JOURNEY_KEY);
    if (existing) return existing;
    const created = randomId();
    storage.setItem(JOURNEY_KEY, created);
    return created;
  } catch {
    return randomId();
  }
}

export function shouldAliasJourney(
  journeyId: string,
  consumerId: string,
  storage: Pick<Storage, 'getItem' | 'setItem'> = window.localStorage,
): boolean {
  const assignment = `${journeyId}:${consumerId}`;
  try {
    if (storage.getItem(ALIAS_KEY) === assignment) return false;
    storage.setItem(ALIAS_KEY, assignment);
    return true;
  } catch {
    return true;
  }
}

export function clearAnalyticsJourney(storage: Pick<Storage, 'removeItem'> = window.localStorage): void {
  try {
    storage.removeItem(JOURNEY_KEY);
    storage.removeItem(ALIAS_KEY);
  } catch {
    // Storage may be unavailable in strict privacy modes.
  }
}
